// Migrated
<template>
  <div
    class="absolute bottom-0 right-0 flex flex-col items-start text-white mb-16 mr-4 rounded-lg overflow-hidden print-hidden"
    :style="{ paddingBottomPx: paddingBottomPx ? `${paddingBottomPx}px` : '' }"
    :class="{ 'pb-5': paddingBottomPx === null }"
  >
    <template v-if="bannerSpecial">
      <LazyCrownText
        v-if="bannerSpecial.type === specials.crown"
        class="mb-1 h-[91px]"
      />
      <LazySpecialBookmark
        v-else-if="bannerSpecial.type === specials.bookmark"
        v-bind="bannerSpecial.data"
      />
    </template>

    <div class="bg-blue-750 min-w-full px-4 pt-2 pb-4">
      <div
        v-if="bannerDays"
        class="text-white mt-2 flex items-center justify-between w-full"
      >
        <div class="flex items-center">
          <fa
            v-if="bannerSpecial && bannerSpecial.type === specials.icon"
            v-bind="bannerSpecial.data"
            size="xl"
            class="h-5 mr-3 aspect-square"
          />
          <span
            class="mb-0 inline mr-2 pr-1 font-semibold"
          >
            {{ bannerDays }}
          </span>
        </div>

        <nuxt-link
          v-if="showNavigationArrow"
          :to="bannerLink?.href || '#'"
          class="w-[18px] h-[18px] block md:hidden"
          @click="$emit('onLinkClick')"
        >
          <fa
            icon="arrow-right"
            class="w-[18px] h-[18px] text-white"
          />
        </nuxt-link>
      </div>

      <div
        v-if="bannerSubtitle"
        class="text-base py-1 font-semibold"
        :data-i18n="bannerSubtitleI18n"
        data-allow-mismatch
      >
        {{ bannerSubtitle }}
      </div>

      <div
        class="text-2xl py-1 font-bold"
        :data-i18n="bannerTitleI18n"
        data-allow-mismatch
      >
        {{ bannerTitle }}
      </div>

      <div
        v-if="bannerStars?.score"
        class="flex items-center text-center"
      >
        <LazyStars
          class="mr-2"
          is-star
          :score="bannerStars?.score"
          :size="bannerStars.reviewCount ? 'sm' : 'lg'"
          type="inline"
        />
        <small
          v-if="bannerStars?.reviewCount"
          class="text-white ml-2 font-secondary text-sm"
        >{{ $t('outOfReviews', { n: bannerStars.reviewCount }) }}</small>
      </div>
    </div>

    <div class="min-w-full bg-white">
      <div
        v-if="bannerPrice"
        class="flex justify-between items-end px-4 pb-4 pt-1 text-black"
      >
        <div>
          <div class="mb-0 mr-2 inline-block mt-3">
            {{ $t('shortFromPrice') }}
          </div>
          <span
            v-if="bannerPriceWithoutDiscount"
            class="mb-0 mr-2 inline-block strikethrough before:!border-black"
          >
            {{ $n(bannerPriceWithoutDiscount) }}
          </span>
          <span class="mb-0 mr-2 inline-block font-bold text-3xl text-blue-750">
            {{ $n(bannerPrice) }}
          </span>
        </div>

        <div
          v-if="bannerLink || bannerLinkButton"
          class="flex justify-center text-center mt-3"
        >
          <nuxt-link
            v-if="bannerLink"
            :class="[
              'btn-secondary hover-muted ml-3 py-2 btn normal-case font-semibold !px-5 flex items-center',
              { 'hidden md:inline-flex': showNavigationArrow }
            ]"
            :to="bannerLink?.href || '#'"
            :data-i18n="bannerLink?.textI18n"
            @click.prevent="$emit('onLinkClick')"
          >
            {{ bannerLink?.text }}
            <fa
              class="pl-1"
              icon="arrow-right"
            />
          </nuxt-link>
          <button
            v-else-if="bannerLinkButton"
            :class="[
              bannerLinkButton?.bgColor ? `bg-${bannerLinkButton.bgColor}` : '',
              'btn-secondary hover-muted ml-3 py-2 btn normal-case font-semibold !px-5 flex items-center',
              { 'hidden md:inline-flex': showNavigationArrow }
            ]"
            :data-i18n="bannerLinkButton?.textI18n"
            @click="$emit('onLinkClick', bannerLinkButton?.href)"
          >
            {{ bannerLinkButton?.text }}
            <fa
              class="ml-2"
              icon="arrow-right"
            />
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="slots['below-right']"
    class="absolute bottom-0 right-0 -mr-6"
  >
    <div class="!rounded-t-md overflow-hidden">
      <slot name="below-right" />
    </div>
  </div>
</template>

<script setup>
import { specials } from '@layers/web/constants/banner.js'

defineEmits(['onLinkClick'])

const slots = useSlots()

const rootStore = useRootStore()

const {
  pageBannerTitle: bannerTitle,
  pageBannerTitleI18n: bannerTitleI18n,
  pageBannerSubtitle: bannerSubtitle,
  pageBannerSubtitleI18n: bannerSubtitleI18n,
  pageBannerLink: bannerLink,
  pageBannerLinkButton: bannerLinkButton,
  pageBannerStars: bannerStars,
  pageBannerPrice: bannerPrice,
  bannerPriceWithoutDiscount: bannerPriceWithoutDiscount,
  pageBannerDays: bannerDays,
  pageBannerSpecial: bannerSpecial,
  pagePaddingBottomPx: paddingBottomPx,
  showNavigationArrow: showNavigationArrow,
} = storeToRefs(rootStore)
</script>
